export function useSettingVideoSEO({
    key,
    title,
    description,
    contentUrl,
    thumbnailUrl,
}: {
    key: string
    title: string
    description: string
    contentUrl: string
    thumbnailUrl: string
}) {
    return useHead({
    script: [
        {
            key: key,
            type: 'application/ld+json',
            innerHTML: computed(() =>
                JSON.stringify({
                    '@context': 'https://schema.org',
                    '@type': 'VideoObject',
                    name: title,
                    description: description,
                    contentUrl: contentUrl,
                    thumbnailUrl: thumbnailUrl,
                    uploadDate: '2025-10-20T00:00:00+08:00',
                    duration: 'PT1M30S',
                    encodingFormat: 'video/mp4',
                })
            ),
        },

    ],
})
}

 